<div class="dialog-wrapper">
    <div class="icon-wrapper">
        <i class="icon icon-status" [inlineSVG]="'#check-success'"></i>
    </div>
    <div mat-dialog-title class="title-wrapper">
        <h2 class="status-title">{{ data.title | translate }}</h2>
    </div>
</div>
